module.exports = __webpack_public_path__ + "static/media/sign-in-background.44f25fa4.png";